// extracted by mini-css-extract-plugin
module.exports =  {"box":"aANDjEU","box-hidden":"VWeGcbO","boxHidden":"VWeGcbO","with-animation":"TkMM0iw","withAnimation":"TkMM0iw","fadeIn":"mrFQ8bo","content":"_F078LJ"};